import ProductName from "./ProductName";

## Basic Usage

<ProductName productName="Studio" />

---

## With Beta Badge

<ProductName productName="Analytics" beta />

---

## Different Product Names

<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
  <ProductName productName="Designer" />
  <ProductName productName="Builder" />
  <ProductName productName="Analytics" beta />
  <ProductName productName="Insights" />
</div>

---

## With Title Tooltip

<ProductName productName="Studio" title="Higharc Studio - Design your dream home" />

Hover to see the tooltip.

---

## Mobile Logo Only

On mobile, you might want to show only the logo:

<ProductName productName="Studio" mobileLogoOnly />

(Resize viewport to see effect)

---

## In a Header

<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "1rem", borderBottom: "1px solid #e5e5e5" }}>
  <ProductName productName="Designer" />
  <div style={{ display: "flex", gap: "1rem" }}>
    <span style={{ fontSize: "0.875rem", color: "#64748b" }}>user@example.com</span>
  </div>
</div>

